import utils from '@eitje/utils'
import {filters as FILTERS} from '@eitje/bridge'
import _ from 'lodash'

export const useFilterTaxonomies = ({filters, unfilteredItems, filtersCacheKey, orgCacheKey}) => {
	filters = utils.alwaysArray(filters).map(filter => (_.isString(filter) ? {name: filter} : filter))

	// 1. Let filters access the unfilteredItems to fill the ListPicker.
	// 2. Find cached but missing users with the cache keys, see comments in useUserFilter.
	const filterProps = {unfilteredItems, filtersCacheKey, orgCacheKey}

	filters = filters
		.map(({name, ...options}) => {
			const filterName = _.snakeCase(name)
			const transKey = `filters.filter.${filterName}.name`
			const filterTaxFn = FILTERS[`use${_.upperFirst(name)}Filter`]
			const filterTax = filterTaxFn({...options, ...filterProps})

			// Filters can disable themselves by returning (e.g. a environment filter in a single env org).
			if (!filterTax) return
			return {filterName, transKey, options, ...filterTax}
		})
		.filter(Boolean)

	// Hide filters which have no items.
	// E.g. the environment in leave, where the envRoleScope "verlof" can filter out all environments.
	return filters.filter(tax => tax.items.length)
}
